<template>
  <div class="mod-web-footer"></div>
</template>

<script>
export default {
  name: 'ModWebFooter'
}
</script>

<style lang="postcss">
.mod-web-footer {
  height: 230px;
  background: url(../assets/images/bg-home-5.png) #ecfafb no-repeat center;
}
</style>
